import type { ReactNode } from 'react';
import { Avatar, Space, Text, Title } from 'ui';

type P = {
  actions?: ReactNode;
  description?: string;
  icon?: ReactNode;
  name: string;
  src?: string;
};

const ChatInfoProfile = ({ actions, description, icon, name, src }: P) => (
  <Space align="center" block orientation="vertical" size="ms">
    <Avatar icon={icon} size="xxxl" src={src} />
    <Space align="center" orientation="vertical" size="xxs">
      <Title className="chat-info-profile__title" ellipsis={{ rows: 2, tooltip: true }} level={1}>
        {name}
      </Title>
      {description ? <Text type="secondary">{description}</Text> : null}
    </Space>
    {actions}
  </Space>
);

export default ChatInfoProfile;
